import React from 'react';
import { Link } from 'react-router-dom';
import '../../css/legal.css';

const TermsOfService = () => (
    <div className="tamcare-legal-page">
        <div className="tamcare-legal-shell">
            <h1>Điều khoản sử dụng</h1>
            <p className="tamcare-legal-updated">Cập nhật: 21/06/2026</p>

            <section>
                <h2>1. Chấp nhận điều khoản</h2>
                <p>
                    Bằng việc đăng ký hoặc sử dụng TamCare (website và ứng dụng di động), bạn đồng ý với các
                    điều khoản này và <Link to="/privacy">Chính sách bảo mật</Link>.
                </p>
            </section>

            <section>
                <h2>2. TamCare là gì — và không phải là gì</h2>
                <p>
                    TamCare là <strong>công cụ số</strong> giúp người dùng ghi chép, lưu trữ và xem lại thông
                    tin cá nhân; đặt lịch nhắc uống thuốc; kết nối với người thân; và (tùy chọn) nhận{' '}
                    <strong>gợi ý tham khảo</strong> từ trợ lý AI dựa trên dữ liệu bạn cung cấp.
                </p>
                <p>TamCare <strong>không phải</strong>:</p>
                <ul>
                    <li>Thiết bị y tế hoặc phần mềm thay thế thiết bị đo chuyên dụng.</li>
                    <li>Dịch vụ khám chữa bệnh, telemedicine, chẩn đoán, kê đơn hay điều trị.</li>
                    <li>Hệ thống cấp cứu hoặc giám sát y tế liên tục theo tiêu chuẩn bệnh viện.</li>
                </ul>
            </section>

            <section>
                <h2>3. Các tính năng chính</h2>
                <ul>
                    <li>
                        <strong>Nhắc uống thuốc:</strong> bạn tự nhập lịch và tên thuốc; app chỉ gửi nhắc nhở
                        theo lịch đã đặt.
                    </li>
                    <li>
                        <strong>Nhập &amp; xem chỉ số:</strong> bạn tự nhập số liệu; app hiển thị biểu đồ và
                        lịch sử để dễ theo dõi.
                    </li>
                    <li>
                        <strong>Hồ sơ cá nhân:</strong> lưu tài liệu và ghi chú do bạn tải lên hoặc gõ.
                    </li>
                    <li>
                        <strong>Liên kết người thân:</strong> chia sẻ mã kết nối với người bạn tin cậy.
                    </li>
                    <li>
                        <strong>Trợ lý AI &amp; gợi ý tham khảo:</strong> xem mục 4 và 5 bên dưới.
                    </li>
                </ul>
            </section>

            <section>
                <h2>4. Trợ lý AI (ChatBox)</h2>
                <ul>
                    <li>
                        Tính năng chat sử dụng trí tuệ nhân tạo để trả lời câu hỏi chung về sức khỏe và sinh
                        hoạt dựa trên nội dung bạn gửi.
                    </li>
                    <li>
                        Câu trả lời <strong>chỉ mang tính tham khảo</strong>, có thể không đầy đủ hoặc không
                        phù hợp với tình trạng cụ thể của bạn.
                    </li>
                    <li>
                        Bạn <strong>không được</strong> dùng chat AI làm cơ sở duy nhất để tự chẩn đoán, tự
                        điều trị, thay đổi liều thuốc hoặc trì hoãn việc đi khám khi có triệu chứng nặng.
                    </li>
                    <li>
                        Khi có dấu hiệu nguy hiểm, gọi <strong>115</strong> hoặc đến cơ sở y tế gần nhất.
                    </li>
                </ul>
            </section>

            <section>
                <h2>5. Nhập chỉ số &amp; phân tích tham khảo (AI engine)</h2>
                <ul>
                    <li>
                        Chỉ số sức khỏe trên TamCare do <strong>người dùng tự nhập</strong>; TamCare không đảm
                        bảo tính chính xác y khoa của dữ liệu nhập tay.
                    </li>
                    <li>
                        Nếu có hiển thị gợi ý, cảnh báo hoặc “phân tích” từ hệ thống AI, đó là{' '}
                        <strong>gợi ý tham khảo</strong> nhằm hỗ trợ bạn chú ý theo dõi thêm —{' '}
                        <strong>không phải chẩn đoán bệnh</strong>.
                    </li>
                    <li>
                        Biểu đồ và thông báo không thay thế xét nghiệm, khám lâm sàng hay chỉ định của bác sĩ.
                    </li>
                </ul>
            </section>

            <section>
                <h2>6. Tài khoản</h2>
                <ul>
                    <li>Bạn chịu trách nhiệm bảo mật mật khẩu và hoạt động trên tài khoản của mình.</li>
                    <li>Số điện thoại là <strong>tùy chọn</strong> khi đăng ký; email và tên đăng nhập dùng để đăng nhập.</li>
                    <li>Người cao tuổi có thể chia sẻ mã kết nối cho người thân đã tin cậy.</li>
                    <li>Bạn có thể xóa tài khoản tại <Link to="/account/delete">trang xóa tài khoản</Link>.</li>
                </ul>
            </section>

            <section>
                <h2>7. Giới hạn trách nhiệm</h2>
                <p>
                    TamCare nỗ lực duy trì dịch vụ ổn định nhưng không đảm bảo không gián đoạn. Chúng tôi không
                    chịu trách nhiệm cho thiệt hại phát sinh từ việc dựa vào thông tin trên ứng dụng (bao gồm
                    nội dung AI, biểu đồ, gợi ý tham khảo) thay cho tư vấn chuyên môn của bác sĩ hoặc cơ sở y
                    tế.
                </p>
            </section>

            <section>
                <h2>8. Liên hệ</h2>
                <p>
                    Email: <a href="mailto:tamcare.contact@gmail.com">tamcare.contact@gmail.com</a>
                    {' · '}
                    Hotline: 082 4599170
                </p>
            </section>

            <p className="tamcare-legal-back">
                <Link to="/">← Về trang chủ</Link>
                {' · '}
                <Link to="/privacy">Chính sách bảo mật</Link>
            </p>
        </div>
    </div>
);

export default TermsOfService;
